import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import { GetHypnowheelResponseType } from '@/entities';

export const getHypnowheel = async (
  tgInitData?: string
): Promise<GetResponseType<GetHypnowheelResponseType>> => {
  return await ApiClient.get<GetHypnowheelResponseType>(
    `${window.config.api_endpoint}/users/me/game/hypnowheel`,
    tgInitData || WITH_AUTH
  );
};

export const getSpinData = async (
  tgInitData?: string
): Promise<GetResponseType<GetHypnowheelResponseType>> => {
  return await ApiClient.get<GetHypnowheelResponseType>(
    `${window.config.api_endpoint}/users/me/game/hypnowheel/spin`,
    tgInitData || WITH_AUTH
  );
};

export const postSpinCompleted = async (
  nonce: string,
  tgInitData?: string
): Promise<GetResponseType<GetHypnowheelResponseType>> => {
  return await ApiClient.post<GetHypnowheelResponseType>(
    `${window.config.api_endpoint}/users/me/game/hypnowheel/spin`,
    [nonce],
    tgInitData || WITH_AUTH
  );
};
